import { motion } from 'framer-motion';
import styled from 'styled-components';
import { mediaMobile } from 'utils/styles/responsive';
import { colors, layout } from 'utils/styles/theme';

export const Wrapper = styled.div`
    position: fixed;
    width: 100vw;
    height: 100svh;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: ${layout.zIndex.modals};
    pointer-events: none;
    transition: opacity 0.4s;
`;


export const Content = styled(motion.div)`
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  text-align: center;
  user-select: none;
  color: ${colors.white};
  text-align: center;
  transition: transform 1.2s cubic-bezier(0.4, 0.0, 0.2, 1), gap 1s cubic-bezier(0.4, 0.0, 0.2, 1);
  animation: fadeIn 0.3s ease-in-out forwards;
  // transform: translateY(100rem); 
  will-change: transform, gap;
  gap: 36px; 
  transform: translateY(30vh);  

    > h5 {      
        margin-top: 10rem;
    }

    ${mediaMobile(`    
        transform: translateY(30vh);
         > h5 {
            margin-top: 5rem;
        }
  `)}
        

   &.finalState {
      gap: 16px; 
      transform: translateY(5vh);

      ${mediaMobile(`    
        transform: translateY(15vh);
      `)}
    }

  @keyframes fadeIn {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
}
`;



export const ContentTitle = styled.h1`
  font-family: FontRegular;
  color: #FFF;
  text-transform: uppercase;
  text-shadow: 0px 0px 8px rgba(0, 0, 0, 1);
  line-height: 1;
  transition: transform 0.8s cubic-bezier(0.4, 0.0, 0.2, 1);
  will-change: transform;
  font-size: 100rem;
    
  ${mediaMobile(`        
    font-size: 40rem;
  `)}

  &.finalState {
    // font-size: 48px;
    transform: scale(0.6);

  ${mediaMobile(`    
      // top: 208px;
      // font-size: 32px;
      transform: scale(0.8);
  `)}
  }

  
  // ${mediaMobile(`    
  //   font-size: 32rem;
  //   letter-spacing: 0.6rem;
  // `)}
`;

export const ContentSubtitle = styled.h2`
    font-family: FontLight;  
    // font-size: 24px;
    line-height: normal;
    letter-spacing: 6.48px;
    text-transform: uppercase;
    text-shadow: 0px 0px 8px rgba(0, 0, 0, 1);
    transition: transform 0.8s cubic-bezier(0.4, 0.0, 0.2, 1);
    will-change: transform;
    letter-spacing: 4.32px;

    // &.initialState {
      font-size: 30rem;
      // margin-top: 60rem;
      
      ${mediaMobile(`    
          font-size: 14rem;
      `)}
    // }
  
    &.finalState {
    // font-size: 24px;
      transform: scale(1.05) translateY(-15px);
    
      ${mediaMobile(`    
        transform: scale(1.05) translateY(-5px);
      `)}
    }
`;

export const ButtonStart = styled.h3`
  margin-top: 83px;
  height: 28rem;
  cursor: pointer;
  pointer-events: all;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: opacity 0.4s ease-in-out;
  opacity: 1;
  
  &.finalState {
    opacity: 0 !important;
  }

  > svg {
    width: auto;
    height: 100%;
    margin: 0 15rem;
  }
  > img {
    width: auto;
    height: 150%;
    margin: 0 15rem;
  }

  ${mediaMobile(`
    margin-top: 5vh;
    height: 13rem;
    > svg {
      margin: 0 10rem;
    }
  `)}
`;

export const ButtonStartText = styled.p`
  font-family: FontLight;
  font-size: 16px;
  line-height: normal;
  letter-spacing: 2.56px;
  text-transform: uppercase;
  white-space: nowrap;
  margin-right: 30rem;
  color: ${colors.white};
  ${mediaMobile(`    
    margin-right: 15rem;
    font-size: 10rem;
    line-height: normal;
    letter-spacing: 1.92px;
    text-transform: uppercase;
  `)}
`;

export const Disclaimer = styled(motion.div)`
  position: absolute;
  left: 50%;
  bottom: 20px;
  transform: translateX(-50%);
  font-family: FontLight;
  font-size: 12px;  
  width: 90%;
  color: #FFF;
  text-align: center;
  transition: opacity 0.4s ease-in-out;
  opacity: 1;
  ${mediaMobile(`    
    font-size: 10px;
  `)}
  
  &.finalState {
    opacity: 0 !important;
  }
`;